import axios from "@util/axios";
import projectConfig from "@projectConfig";

const { hostCloud } = projectConfig.api;
const token = localStorage.getItem("token");

export const addGeneralTimer = async (data) => {
    return axios({
       method: "POST",
       url: `${hostCloud}/timer/general`,
       headers: {
          Accept: "*/*"
       },
       data: data,
       params: {
         startOnCreate: true
      }
    });
 };

 export const stopTimer = async (timerId) => {
   await fetch (`${hostCloud}/timer/general/stop-and-save?timerId=${timerId}`, {
       method: "PUT",
       headers: {
          Accept: "*/*",
         "Content-Type": "application/json",
       },
       params: {
          timerId
       },
       credentials: "include",
       keepalive: true
    });
 };

 export const initiateTimer = async (timerId) => {
   return axios({
      method: "PUT",
      url: `${hostCloud}/timer/general/start-or-pause`,
      headers: {
         Accept: "*/*"
      },
      params: {
         timerId
      }
   });
};